import { Text } from '#app/components/Primitives/Text.js';
import { NAVBAR_HEIGHT } from './constants.js';
import { css, styled } from 'styled-components';

const Navbar = styled.nav<{
  $hideAppBarBorderAtMd?: boolean;
}>`
  ${({ $hideAppBarBorderAtMd, theme }) => css`
    width: 100%;
    position: sticky;
    top: 0;
    z-index: ${theme.zIndices.toolbar};
    background: ${theme.colorsV2.white};
    height: max-content;

    ${theme.mediaQueries.md} {
      border-bottom: ${$hideAppBarBorderAtMd
        ? 'none'
        : css`
            ${theme.colorsV2.gray20} 1px solid
          `};
    }
  `}
`;

const Spacer = styled.div`
  height: ${NAVBAR_HEIGHT}px;
`;

export const BannerContainer = styled.div`
  ${({ theme }) => css`
    width: 100%;
    background: ${theme.colorsV2.gray10};
  `}
`;

export const BannerLayout = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  width: 100%;
`;
export const BannerContent = styled.div`
  flex: 1;
`;

const Layout = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
    padding: 8px 16px;
    width: 100%;
    position: relative;
    z-index: 1;

    ${theme.mediaQueries.md} {
      padding: 8px 32px 8px 32px;
    }
  `}
`;

const Center = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  padding: 0px 8px;
`;

const Left = styled.div`
  display: flex;
  align-items: center;
  z-index: 3;
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;

  li {
    margin: unset;
  }
`;

const Link = styled(Text)`
  ${({ theme }) => css`
    margin-left: 32px;

    display: inline-flex;
    align-items: center;

    color: ${theme.colorsV2.gray70};

    &:hover {
      color: ${theme.colorsV2.black};
    }

    > span {
      font-weight: 600;
      margin-left: 8px;
    }
  `}
`;

export const Nav = Object.assign(
  Navbar,
  {},
  {
    Center,
    Layout,
    Left,
    Link,
    Right,
    Spacer,
  },
);
